// extracted by mini-css-extract-plugin
module.exports = {"file":"file-view_file__2lB88","activeFile":"file-view_activeFile__1CdVI","filetypeIcon":"file-view_filetypeIcon__1p9zy","keyBindings":"file-view_keyBindings__1jCd8"};